<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import {
		dadosUsuarioLS,
		limparLocalStorage,
		TipoEvento,
		verificarLocalStorage,
		verificarSessionStorage
	} from '../../utils';
	import PainelBox from '../templates/PainelBox.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import CartaoQuadrado from '../../componentes/cartoes/CartaoQuadrado.svelte';
	import {sTituloPaginaAtual} from '../../stores';

	export let listaFuncionalidades = [];
	export let titulo = "Painel";
	
	let filtroFuncionalidades = [];
	const dispatch = createEventDispatcher();
	
	onMount(async () => {
		$sTituloPaginaAtual = titulo;

		if (verificarSessionStorage('AVAL_TOKEN') == false || verificarLocalStorage('AVAL_USUARIO_DADOS') == false) {
			
			limparLocalStorage(true, false, false, false);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Necessário realizar login.'
			});

			setTimeout( () => replace('/login'), 1000);
		}

		const dadosUsuario = dadosUsuarioLS();

		// filtra as opções do menu de acordo com o perfil do usuário
		filtroFuncionalidades = listaFuncionalidades.filter( item => {
			return item.perfis.split(',').find(valor => valor == dadosUsuario.perfil);
		});
	});
</script>

<PainelBox 
	largura="12" 
	deslocamento="0">
	<GradeCartoes itens={filtroFuncionalidades} componente={CartaoQuadrado} />
</PainelBox>
